import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { BaseComponent } from '@app/shared/components/base/base.component';
import { CaseService } from '@app/core/services/case.service';
import { CaseOverviewMetaData } from '@app/shared/models/case-overview-meta-data';
import { WidgetColumn, WidgetSettings } from '@app/shared/models/widget';
import { WidgetService } from '@app/core/services/widget.service';
import * as _ from 'lodash-es';

export interface CaseWidgetSettingsDialogData {
    widgetId: string;
    settings: WidgetSettings;
}

export interface CaseWidgetSettingsDialogResult {
    id: string;
    settings: WidgetSettings
}

@Component({
    templateUrl: './case-widget-settings-dialog.component.html',
    styleUrls: ['./case-widget-settings-dialog.component.scss']
})
export class CaseWidgetSettingsDialogComponent extends BaseComponent
    implements OnInit {

    private widgetId: string;
    protected availableColumns: WidgetColumn[];

    public isLoading: boolean = true;
    public tableMetaData: CaseOverviewMetaData;

    public filteredAvailableColumns: WidgetColumn[];
    public curentSelectedColumns: WidgetColumn[];

    public widgetSettings: WidgetSettings;

    constructor(
        private caseService: CaseService,
        private widgetService: WidgetService,
        public dialogRef: MatDialogRef<CaseWidgetSettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CaseWidgetSettingsDialogData
    ) {
        super();
        this._idPrefix = 'case_widget_settings_dialog.';

        this.widgetId = this.data.widgetId;

        this.widgetSettings = data.settings;
        this.curentSelectedColumns = this.widgetSettings.columns;

        // Update sort order if some do not have one yet
        if (_.some(this.curentSelectedColumns, (column) => {
            return !column.sort_order && column.sort_order !== 0;
        })) {
            for (let i = 0; i < this.curentSelectedColumns.length; i++) {
                this.curentSelectedColumns[i].sort_order = i;
            }
        }
    }

    get columns() {
        return this.curentSelectedColumns; // Which columns are selected by user
    }

    public ngOnInit() {

        this.isLoading = true;

        this.caseService.getCasesOverviewMeta()
            .subscribe((metadata: CaseOverviewMetaData) => {
                this.tableMetaData = metadata;

                this.availableColumns = this.tableMetaData.availableColumns; // All existing columns
                this.filterAvailableColumns();

                this.isLoading = false;
            });

        super.ngOnInit();
    }

    public filterAvailableColumns(): void {
        this.filteredAvailableColumns = this.availableColumns.filter(column => {
            return !this.columns.find(selectedColumn => selectedColumn.id === column.id);
        });
    }

    public accept(): void {

        this.widgetSettings.columns = this.columns;

        this.widgetService.saveSettings(this.widgetId, this.widgetSettings)
            .subscribe((response) => {

                const result: CaseWidgetSettingsDialogResult = {
                    id: this.widgetId,
                    settings: this.widgetSettings
                };

                this.dialogRef.close(result);
            });
    }

    public close(): void {
        this.dialogRef.close(false);
    }

}
